import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

// Assets
import logo from "assets/images/logo.svg";
import bCorpBlackLogo from "assets/images/b-corp-logo-black.png";

// Components
import ServerErrorModal from "components/Modals/ServerError/ServerError";
import Portal from "components/Portal/Portal";
import FooterText from "components/FooterText/FooterText";

// Tools
import useWindowSize from "hooks/useWindowSize";

export default function FullPageMessage(props) {
  const { isDesktop } = useWindowSize();
  const fullPageMessageClasses = classNames("container", props.smaller && "smaller");
  return (
    <div className="layout layout-full-page-message">
      <Portal>
        <ServerErrorModal />
      </Portal>
      {!isDesktop && <img src={bCorpBlackLogo} className="b-corp-logo" alt="B-Corp logo" />}
      <div className={fullPageMessageClasses}>
        <img src={logo} className="logo" alt="OI logo" />
        {props.children}
      </div>
      {props.showFooterText && <FooterText />}
    </div>
  );
}

FullPageMessage.propTypes = {
  showFooterText: PropTypes.bool,
  children: PropTypes.node.isRequired,
  smaller: PropTypes.bool,
};
